

/**
 * @ngdoc filter
 * @name app.filter:trustUrl
 * @function
 * @description
 * # trustUrl
 * Filter in the app.
 */
angular.module('app')
	.filter('trustUrl', /* @ngInject */ function ($sce) {
		return url => $sce.trustAsResourceUrl(url);
	});
